import { container, singleton } from "tsyringe";
import { OneTrustConsentStrategy } from "./consentStrategies/one-trust-consent-strategy";
import { ConsentProviderInterface } from "./consentProviders/consent-provider-interface";
import { Providers } from "./consentProviders/providers";

@singleton()
export class ConsentProviderFactory {
  public async get(
    preferredProvider?: Providers,
  ): Promise<ConsentProviderInterface> {
    if (preferredProvider === Providers.ONETRUST) {
      return container.resolve(OneTrustConsentStrategy);
    }

    if (preferredProvider === Providers.COOKIEBOT) {
      // Fanatical is very small part of our traffic. Even though it's ~1.5kB,
      // it's not worth to load it for all users. On top of that,
      // on Fanatical we are loaded after user gives their consent.
      const { FanaticalConsentStrategy } = await import(
        /* webpackChunkName: "fanatical-consents" */ "./consentStrategies/fanatical-consent-strategy"
      );
      return container.resolve(FanaticalConsentStrategy);
    }

    const { StaticConsentStrategy } = await import(
      /* webpackChunkName: "static-consents" */ "./consentStrategies/static-consent-strategy"
    );
    return container.resolve(StaticConsentStrategy);
  }
}
